export const SET_PAYMENT_PROVIDER_OVERRIDE =
  'artful-client/PaymentProvider/SET_PAYMENT_PROVIDER_OVERRIDE';

const initialState = {
  override: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_PAYMENT_PROVIDER_OVERRIDE:
      return {
        ...state,
        override: action.override,
      };
    default:
      return state;
  }
}

export const setPaymentProviderOverride = override => ({
  type: SET_PAYMENT_PROVIDER_OVERRIDE,
  override,
});
